<template>
	<div class="auth-container">
		<div class="auth-bg-orb orb-1"></div>
		<div class="auth-bg-orb orb-2"></div>
		<div class="auth-bg-grid"></div>

		<div class="auth-wrapper">
			<!-- Right Section - Brand (dark) -->
			<div class="auth-brand-section">
				<div class="brand-content">
					<img class="brand-logo" :src="require('@/assets/images/brand/lema-logo-white.svg')" alt="Lema" />
					<h2 class="brand-title">زیرساخت هوشمند توسعه<br />شبکه پذیرندگان</h2>
					<p class="brand-desc">
						از جذب و احراز پذیرنده تا عرضه به لندتک‌ها و کسب‌وکارها — در یک سامانه یکپارچه.
					</p>
					<ul class="brand-points">
						<li><span></span> جذب و احراز یکپارچه پذیرندگان</li>
						<li><span></span> رتبه اعتباری و مدیریت هوشمند ریسک</li>
						<li><span></span> اتصال آماده به لندتک‌ها و کسب‌وکارها</li>
					</ul>
				</div>
			</div>

			<!-- Left Section - Form (glass) -->
			<div class="auth-form-section">
				<div class="auth-card">
					<img class="mobile-logo" :src="require('@/assets/images/brand/lema-logo-color.svg')" alt="Lema" />
					<div class="auth-header">
						<h1 class="auth-title">ورود به پنل مدیریت</h1>
						<p class="auth-subtitle">شماره تلفن خود را برای دریافت کد ورود وارد کنید</p>
					</div>

					<form class="auth-form" @submit.prevent="submitPhone">
						<div class="form-group">
							<Materialnput
								id="admin-login-phone"
								vModel="userPhoneNumber"
								label="شماره تلفن همراه"
								class="modern-input"
								v-model="userPhoneNumber"
								@onEnter="submitPhone"
							/>
						</div>

						<button
							type="submit"
							class="auth-btn primary-btn"
							:disabled="disabled"
							:class="{ 'loading': loading }"
						>
							<span v-if="!loading" class="btn-text">دریافت کد تأیید</span>
							<div v-if="loading" class="btn-spinner">
								<div class="spinner"></div>
							</div>
						</button>

						<div class="auth-divider">
							<span class="divider-text">یا</span>
						</div>

						<button type="button" class="auth-btn secondary-btn" @click="passwordAuth">
							<span class="btn-text">ورود با رمز عبور</span>
						</button>
					</form>
				</div>
				<p class="auth-footer">LEMA · Merchant Network Infrastructure</p>
			</div>
		</div>
	</div>
</template>
<script>
import Materialnput from '../../components/MaterialInput/mobileInput.vue';

export default {
	components: {
		Materialnput,
	},
	data() {
		return {
			userPhoneNumber: '',
			loading: false,
			disabled: true,
		};
	},
	computed: {
		// disabled() {
		// 	if (this.userPhoneNumber === '' || this.userPhoneNumber.length < 11) {
		// 		return true;
		// 	} else {
		// 		return false;
		// 	}
		// },
	},
	mounted() {
		//   ("asdfadsfsdgfs");
		// history.pushState(null, null, location.href);
		// window.onpopstate = function () {
		//   history.go(1);
		// };
	},
	methods: {
		passwordAuth() {
			this.$router.push({ name: "password" });
		},
		
		async submitPhone() {
			this.loading = true;
			// const res = await this.$ApiServiceLayer.auth_post(
			// 	this.$PATH.RELATIVE_PATH.POST.PHONE_NUMBER_OTP_REQ,
			// 	this.$PATH.SERVICE_NAME.AUTH,
			// 	{ phone_number: this.userPhoneNumber },
			// );

			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.PHONE_NUMBER_OTP_REQ,
				this.$PATH.SERVICE_NAME.AUTH,
				{ phone_number: this.userPhoneNumber },
				{},
				false
			);

			if (res.status === 201) {
				this.loading = false;
				await this.$STORE.commit('userConfig/setOtpId', res.data.id);
				await this.$STORE.commit('userConfig/setLoginTempToken', res.data.verification_token);
				this.$STORE.commit('userConfig/setUserPhoneNumber', this.userPhoneNumber);
				this.$router.push({ name: 'verify' });
			}
		},
		rules() {},
	},
	watch: {
		userPhoneNumber(newVal) {
			let phoneNumber = newVal;
			const p2e = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
			const a2e = (s) => s.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
			phoneNumber = p2e(phoneNumber);
			phoneNumber = a2e(phoneNumber);
			phoneNumber = phoneNumber.replace(/\D/g, '');
			phoneNumber = phoneNumber.replace(/[a-zA-Z\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF]/, '');
			(phoneNumber, 'ejaaa');
			this.userPhoneNumber = phoneNumber;
			('xxx', this.userPhoneNumber);
			let x = phoneNumber
				.replace(/[a-zA-Z\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF]/, '')
				.match(/^(?<prefix>([0٠۰])?)?(?<phone>[9٩۹][0-9٠-٩۰-۹]{9})$/);
			this.userPhoneNumber = phoneNumber;
			if (x !== null) {
				this.disabled = false;
			} else {
				this.disabled = true;
			}
		},
	},
};
</script>

<style scoped>
/* Main Container — Lema dark brand */
.auth-container {
	min-height: 100vh;
	position: relative;
	overflow: hidden;
	background:
		linear-gradient(145deg, #1a2332 0%, #223047 48%, #1a2332 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
}

.auth-bg-grid {
	position: absolute;
	inset: 0;
	background-image:
		linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
		linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
	background-size: 64px 64px;
	mask-image: radial-gradient(70% 70% at 50% 40%, #000 30%, transparent 100%);
	-webkit-mask-image: radial-gradient(70% 70% at 50% 40%, #000 30%, transparent 100%);
	pointer-events: none;
}
.auth-bg-orb {
	position: absolute;
	border-radius: 50%;
	filter: blur(90px);
	opacity: 0.5;
	pointer-events: none;
}
.orb-1 {
	width: 520px;
	height: 520px;
	background: radial-gradient(circle, rgba(58, 166, 166, 0.55), transparent 70%);
	top: -160px;
	right: -120px;
}
.orb-2 {
	width: 560px;
	height: 560px;
	background: radial-gradient(circle, rgba(45, 139, 139, 0.5), transparent 70%);
	bottom: -200px;
	left: -140px;
}

.auth-wrapper {
	position: relative;
	z-index: 1;
	display: flex;
	width: 100%;
	max-width: 1080px;
	min-height: 580px;
	background: rgba(255, 255, 255, 0.04);
	backdrop-filter: blur(22px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 28px;
	box-shadow: 0 40px 100px rgba(0, 0, 0, 0.55);
	overflow: hidden;
}

/* Brand Section (dark, right in RTL) */
.auth-brand-section {
	flex: 1.05;
	position: relative;
	display: flex;
	align-items: center;
	padding: 56px 52px;
	background:
		radial-gradient(120% 80% at 100% 0%, rgba(58, 166, 166, 0.16), transparent 55%),
		radial-gradient(120% 80% at 0% 100%, rgba(45, 139, 139, 0.2), transparent 55%),
		linear-gradient(160deg, #223047 0%, #1a2332 100%);
	border-left: 1px solid rgba(255, 255, 255, 0.08);
}
.brand-content {
	color: #eaf1fb;
}
.brand-logo {
	width: 172px;
	height: auto;
	margin-bottom: 34px;
	filter: drop-shadow(0 10px 30px rgba(58, 166, 166, 0.35));
}
.brand-title {
	font-size: 30px;
	font-weight: 700;
	line-height: 1.55;
	margin-bottom: 18px;
}
.brand-desc {
	font-size: 15px;
	line-height: 2;
	color: #a9b8d0;
	margin-bottom: 30px;
	max-width: 420px;
}
.brand-points {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: 14px;
}
.brand-points li {
	display: flex;
	align-items: center;
	gap: 12px;
	font-size: 14px;
	color: #cdd8ec;
}
.brand-points li span {
	width: 22px;
	height: 22px;
	flex: 0 0 22px;
	border-radius: 7px;
	background: linear-gradient(120deg, #3aa6a6, #2d8b8b);
	box-shadow: 0 6px 16px rgba(45, 139, 139, 0.45);
	position: relative;
}
.brand-points li span::after {
	content: '';
	position: absolute;
	left: 7px;
	top: 4px;
	width: 6px;
	height: 10px;
	border: solid #04202b;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
}

/* Form Section (glass) */
.auth-form-section {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 56px 52px;
	background: #f4f8f8;
}
.mobile-logo {
	display: none;
	height: 46px;
	width: auto;
	margin: 0 auto 26px;
}
.auth-card {
	max-width: 380px;
	margin: 0 auto;
	width: 100%;
}
.auth-header {
	margin-bottom: 34px;
}
.auth-title {
	font-size: 27px;
	font-weight: 700;
	color: #172033;
	margin-bottom: 10px;
	line-height: 1.3;
}
.auth-subtitle {
	font-size: 14px;
	color: #526173;
	line-height: 1.9;
	margin: 0;
}

.auth-form {
	display: flex;
	flex-direction: column;
	gap: 22px;
}
.form-group {
	position: relative;
}
.modern-input {
	width: 100%;
}

/* Buttons */
.auth-btn {
	width: 100%;
	height: 54px;
	border: none;
	border-radius: 14px;
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.25s ease;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}
.primary-btn {
	background: linear-gradient(120deg, #3aa6a6 0%, #2d8b8b 55%, #223047 100%);
	color: #fff;
	box-shadow: 0 14px 34px rgba(45, 139, 139, 0.4);
}
.primary-btn:hover:not(:disabled) {
	transform: translateY(-2px);
	box-shadow: 0 18px 44px rgba(45, 139, 139, 0.55);
	filter: brightness(1.05);
}
.primary-btn:disabled {
	background: #c9dddd;
	color: #36535a;
	cursor: not-allowed;
	transform: none;
	box-shadow: none;
}
.secondary-btn {
	background: #ffffff;
	color: #172033;
	border: 1px solid #b8c8d0;
	backdrop-filter: blur(10px);
}
.secondary-btn:hover {
	background: #eef7f7;
	border-color: #2d8b8b;
	transform: translateY(-1px);
}
.btn-text {
	transition: opacity 0.3s ease;
}
.btn-spinner {
	position: absolute;
}
.spinner {
	width: 20px;
	height: 20px;
	border: 2px solid rgba(255, 255, 255, 0.3);
	border-top: 2px solid #fff;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

/* Divider */
.auth-divider {
	position: relative;
	text-align: center;
	margin: 4px 0;
}
.auth-divider::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	height: 1px;
	background: #c9d5dc;
}
.divider-text {
	background: #f4f8f8;
	color: #526173;
	padding: 0 16px;
	font-size: 13px;
	position: relative;
}
.auth-footer {
	text-align: center;
	margin: 30px 0 0;
	font-size: 12px;
	letter-spacing: 1px;
	color: #66758a;
}

/* Responsive */
@media (max-width: 860px) {
	.auth-wrapper {
		flex-direction: column;
		max-width: 460px;
		min-height: auto;
	}
	.auth-brand-section {
		display: none;
	}
	.mobile-logo {
		display: block;
	}
	.auth-form-section {
		padding: 44px 28px;
	}
}
@media (max-width: 480px) {
	.auth-form-section {
		padding: 34px 20px;
	}
	.auth-title {
		font-size: 23px;
	}
	.auth-btn {
		height: 50px;
	}
}

/* Focus */
textarea:focus,
input:focus {
	outline: none;
}
.auth-btn:focus-visible {
	outline: 3px solid rgba(45, 139, 139, 0.32);
	outline-offset: 3px;
}
.loading .btn-text {
	opacity: 0;
}

/* Adapt the shared MaterialInput to the dark glass form */
.modern-input ::v-deep .edit-container {
	margin-top: 0;
	margin-bottom: 0;
}
.modern-input ::v-deep input {
	box-sizing: border-box;
	background: #ffffff !important;
	border: 1px solid #aebfc8 !important;
	border-radius: 12px !important;
	color: #172033 !important;
	caret-color: #2d8b8b;
	height: 52px !important;
	font-size: 16px !important;
	font-weight: 500 !important;
	padding: 8px 16px !important;
}
.modern-input ::v-deep input:hover {
	border-color: #76999f !important;
}
.modern-input ::v-deep input:focus,
.modern-input ::v-deep input:valid {
	border-color: #2d8b8b !important;
	box-shadow: 0 0 0 4px rgba(45, 139, 139, 0.16);
}
.modern-input ::v-deep input::placeholder {
	color: #64748b !important;
}
.modern-input ::v-deep label {
	right: 14px !important;
	color: #334155 !important;
	background: #ffffff !important;
	font-size: 13px !important;
	font-weight: 600 !important;
	line-height: 1.4 !important;
	padding: 0 7px !important;
}
.modern-input ::v-deep input:focus ~ label,
.modern-input ::v-deep input:valid ~ label {
	color: #1f7373 !important;
	background: #ffffff !important;
	font-size: 12px !important;
}
</style>
